module.exports = __webpack_public_path__ + "img/pic_usa_02.aa67d6df.jpg";